import React from 'react';
import { getFileIconByType } from "../../../common";
import { Thumbnail } from "../..";
import { CarousalConstants } from '../constants';
import { StyledThumbnailView } from '../style';
/**
 *
 * @param props ICarouselItemTypeProps
 * @returns ThumbnailView - component
 */
export const ThumbnailView = (props) => {
    const { file, index } = props.carouselViewProps;
    return (React.createElement(StyledThumbnailView, { key: index },
        React.createElement(Thumbnail, { id: index, defaultIcon: getFileIconByType(file.fileType), className: CarousalConstants.CLASS_THUMBNAIL_CONTAINER })));
};
//# sourceMappingURL=ThumbnailView.js.map